import { Fragment, useEffect, useState } from "react";
import AgentStatusEmpty from "./agentStatusEmpty";
import { CallService } from "../../../../services/call_service";
import { CcassstatusDot } from "../../../../shared/widges/avatarGroup/statusDot";
import { GetItemFromStorage } from "../../../../custom_hooks/useStorage";
import { LocalStorage } from "../../../../custom_hooks/localStorageKeys";
import { agentTrackerActions } from "../../../../store/slices/trackerStatus_slice/agentTrackerslice";
import callChatService from "../../../../base/service/chatService";
import styles from "./agentStatus.module.scss";
import { useDispatcher } from "../../../../custom_hooks/use_app_dispatch";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { CallServices, CoreServices } from "../../../../base/service/apiServices";
import sms from "../../../../styles/images/sms.svg";
import email from "../../../../styles/images/email.svg";
import mailicon from "../../../../styles/images/mailicon.svg";
import whatsapp from "../../../../styles/images/whatsapp.svg";
import mailb from "../../../../styles/images/mailb.svg";
import chatsmall from "../../../../styles/images/chatsmall.svg"
import smsbig from "../../../../styles/images/smsbigicon.svg";
import  insta from "../../../../styles/images/instalogo.svg"
import call from "../../../../styles/images/call.svg";
import callsmall from "../../../../styles/images/callsmall.svg";
import { ChatActions } from "../../../../store/slices/chat_slice/chat_slice";
import store from "../../../../store/redux-store/root_store";
import { ChatState } from "../../../../base/models/model";
import { CallPopUpAgentActions } from "../../../../store/slices/voice_call_slice/call_popup_agent";
import { getLiveSessions } from "../../../contact/base/utils";
import moment from "moment-timezone";
import { getContactDetailsWhilegettingChat } from "../../../../store/api/helperspi/contactListapiService";
import { ROLES } from "../../../../base/constant";
import fbl from "../../../../styles/images/fbs.svg"
import fbs from "../../../../styles/images/fb.svg"
import instagram from "../../../../styles/images/Instagram.svg";
import instas from "../../../../styles/images/instab.svg"
function AgentStatusTracker(props: any) {
  let { DrawerControlfun }: any = props;
  const dispatch = useDispatcher();
  const navigate = useNavigate();
  const { transferChanges, makeReInvite } = CallService(dispatch, navigate);
  const { agentTrackerData, liveSessions }: any = useSelector((state: any) => state.agentTracker);
  const [userListDetails, setUserListDetails] = useState([]);
  // const [liveSessions, setLiveSessions] = useState([]);
  const userDetails = GetItemFromStorage(LocalStorage.USER_DETAILS);
  const LoginUserDetails: any = userDetails;
  const LoginCcaasUserDetails = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS);
  const roomData: any = store.getState().chatReducer;
  const userRoleId = GetItemFromStorage(LocalStorage.ROLE_ID);
  const user_ext: any = GetItemFromStorage(LocalStorage.LOGIN_USER_CCAAS_DETAILS)
  const chatReducer: ChatState = useSelector((state: any) => state.chatReducer);
  let { internalSessionId, internalSessionDetailswhilePopup } = chatReducer;
  const popUpDetails: any = useSelector((state: any) => state.callPopUpDetails);
  let { trackAgentDetail } = popUpDetails;
  let displayedAgents = new Set();
  const [counter, setCounter] = useState<any>(0);
  const [userDetailsFromApi, setUserDetailsFromApi] = useState<any>();
  useEffect(() => {
    setCounter(0);
    const timer = setInterval(() => {
      setCounter((count: any) => count + 1);
    }, 1000);
  }, []);

  const listenAction = async (_sessionData: any) => {
    try {
      let userList = await CoreServices.get(`/get_all_user_list`).then((resp: any) => { return resp.data.getAllUserList; });
      let session = userList?.filter((ob: any) => { if (ob.ext == _sessionData.ext) return ob });
      let sessionData = {
        "stateTimer": _sessionData.stateTimer,
        "Timer": _sessionData.Timer,
        "statusName": _sessionData.statusName,
        "name": _sessionData.name,
        "voice": _sessionData.voice,
        "sms": _sessionData.sms,
        "socialMedia": _sessionData.socialMedia,
        "chat": _sessionData.chat,
        "email": _sessionData.email,
        "emailId": _sessionData.emailId,
        "ext": _sessionData.ext,
        "callType": _sessionData.callType,
        "sessionId": (session?.length && session?.[0]?.currentSession) ? session?.[0]?.currentSession : _sessionData.sessionId,
        "domainId": _sessionData.domainId,
      };

      let data: any = {
        session_id: sessionData?.sessionId,
        req_type: "SUPERVISOR",
        switch_type: 1,
        email: LoginCcaasUserDetails?.emailId ?? '',
        name: LoginCcaasUserDetails?.UserName ?? '',
        userId: LoginCcaasUserDetails?.UserID ?? '',
        ext: LoginCcaasUserDetails?.ext ?? '',
        roleId: LoginCcaasUserDetails?.roleid ?? '',
      };
      DrawerControlfun(false);
      callChatService.sendReqFeatures(data);
      makeReInvite(sessionData?.sessionId, "LISTEN", sessionData);
    } catch (error) {
      console.log('listen error:', error)
    }
  };

  // useEffect(() => {
  //   setInterval(() => {
  //     dispatch(agentTrackerActions.agentTimer());
  //   }, 1000);
  // }, []);
  useEffect(() => {
    const getUserList = async () => {
      let userList: any = await CoreServices.get(`/get_all_user_list`);
      setUserDetailsFromApi(userList?.data?.getAllUserList)
      let sortedUserList = userList?.data?.getAllUserList.sort((a: any, b: any) => a.ext - b.ext).filter((row:any)=>row?.roleid===6||row?.roleid===5||row?.roleid===3);
      setUserListDetails(sortedUserList);
      let agentList = sortedUserList?.filter((elem: any) => elem.roleId === ROLES?.AGENT_ROLE_ID);
      if(userRoleId == ROLES?.ADMIN_ROLE_ID || userRoleId == ROLES?.SUPERVISOR_ROLE_ID ){
        await getLiveSessions(dispatch);
      }
    }
    getUserList();

    // const getLiveSessions = async () => {
    //   let liveSessions = await CoreServices.get(`/get_agent_tracker`);
    //   setLiveSessions(liveSessions?.data?.agentTrackerRes);
    // }

  }, []);
  useEffect(() => {

  }, [liveSessions])


  useEffect(() => {
    let temp: any = [];
    agentTrackerData.map((dt: any) => {
      userListDetails.map((val: any) => {
        if (`${dt?.ext}` === `${val?.ext}`)
           {          temp.push({ ...val, statusName: dt?.statusName })
        }
      })
    })
    let sortedUserList = temp?.sort((a: any, b: any) => a.ext - b.ext);
    setUserListDetails(sortedUserList);
  }, [agentTrackerData]);

  const handleInitials = (name: any) => {
    let temp = name.split(" ").map((val: any) => val.slice(0, 1)).join("").toUpperCase();
    return temp;
  }

  const handleShowValue = (data: any, value: any) => {
    let temp: any = [];
    userListDetails.forEach((val: any) => {
      if (val?.ext === data?.ext) {
        temp.push({ ...data, showDetails: (value === undefined || value === false) ? true : false });
      } else {
        temp.push(val);
      }
    })
    setUserListDetails(temp);
  }

  const handleAgentChats = async (data: any, str: any) => {
    sessionStorage.setItem('supervisorWhisperStatus', str);
    sessionStorage.setItem('agentNameForWhisper', data?.agentName);
    dispatch(ChatActions.supervisorWhisperStatus(str));
    await CallServices.get(`/get_chatSessionId/${data?.historyId}`).then(async (response: any) => {
      //await axios.get(`http://localhost:5007/callservice/v1/get_chatSessionId/${roomData?.internalSessionDetailswhilePopup?.ChatHistoryId}`).then(async (response: any) => {
      if (response.data.statusCode === 200) {
        const customerData: any = await getContactDetailsWhilegettingChat(response?.data?.result[0]?.CustomerId)
        dispatch(ChatActions.agentViewWorkSpaceHistory(response?.data?.result[0]?.sessionId));
        let chatSessionData: any = response?.data?.result[0] ?? {};
        chatSessionData.Number = response?.data?.result[0]?.Number;
        chatSessionData.calledPersonDetails = customerData?.data?.getContactDetailsRes[0];
        chatSessionData['dialDuration'] = data?.sessionStartTime;
        chatSessionData['channelType'] = data?.channelType;
        chatSessionData.ChatDurationHistoryId = data?.durationHistoryId;
        chatSessionData.showState = true;
        chatSessionData.agentExt = data?.agentExt;
        if (str === "view") chatSessionData["supervisorStatus"] = "view";
        if (str === "whisper") chatSessionData["supervisorStatus"] = "whisper";
        //if(str === "barge") chatSessionData["supervisorStatus"] = "barge";
        sessionStorage.setItem('supervisorStatus', chatSessionData?.supervisorStatus);
        dispatch(ChatActions.chatSessionList(chatSessionData));
        dispatch(ChatActions.currentChatSession(chatSessionData));
        dispatch(ChatActions.acceptChat(chatSessionData));

        await CallServices.get(`/get_customer_history/${data?.durationHistoryId}`).then((response: any) => {
          if (response.data.statusCode === 200) {
            let test = JSON.parse(response.data.customerValidateData[0][0].Message) ?? [];
            const messageText = response.data?.messageList;
            messageText?.map((list: any) => {
              if (list.hasOwnProperty("userText")) {
                dispatch(ChatActions.agentWorkSpaceHistory({ agent_work_space_history: list.userText.message }));
                dispatch(ChatActions.storeCurrentSessionMsgHistory(list.userText.message));
              }
              if (list.hasOwnProperty("agentText")) {
                dispatch(ChatActions.agentWorkSpaceHistory({ agent_work_space_history: list.agentText.message }));
                dispatch(ChatActions.storeCurrentSessionMsgHistory(list.agentText.message));
              }
            });
          }
        });
      }
    });
    DrawerControlfun(false);
    navigate("/chatscreenagent");
  };
  const doBarge = () => {
    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 3,
      // ext: accessTokenValues.ext,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };
    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.MonitorType("BARGE"));
  };

  const doWhisper = () => {
    let data: any = {
      session_id: trackAgentDetail?.sessionId,
      req_type: "SUPERVISOR",
      switch_type: 2,
      // ext: accessTokenValues.ext,
      email: LoginCcaasUserDetails?.emailId ?? '',
      name: LoginCcaasUserDetails?.UserName ?? '',
      userId: LoginCcaasUserDetails?.UserID ?? '',
      ext: LoginCcaasUserDetails?.ext ?? '',
    };
    callChatService.sendReqFeatures(data);
    dispatch(CallPopUpAgentActions.MonitorType("WHISPER"));
  };


  const calculateFormattedTime: any = (sessionStartTime: any) => {
    // let systemTime = Date.now();
    let systemTime: any = moment.tz('Europe/London').format('x')
    let timeDifference = Math.floor(systemTime) - sessionStartTime;
    let hours = Math.floor(timeDifference / (1000 * 60 * 60));
    let minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    let formattedTime = '';
    if (hours >= 24) {
      const days = Math.floor(hours / 24);
      hours %= 24;
      formattedTime += `${days}d `;
    }
    formattedTime += `${hours}h ${minutes}m ${seconds}s`;
    return formattedTime;
  }


  return (
    userListDetails?.length <= 0
      ? <AgentStatusEmpty />
      :
      <>
        <h4 className={styles.titletags}>Active Agent</h4>
        {userListDetails
          ?.filter((data: any) => data?.UserID !== LoginCcaasUserDetails?.UserID)
          ?.map((data: any, index: any) => {
           if (LoginCcaasUserDetails?.roleid === 3) {
            return (<Fragment key={index}>
              <>
                <div className={styles.agenttrackernew}>
                  <div className={styles.agenttrackermain} onClick={() => handleShowValue(data, data?.showDetails)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none" className={styles.arrowmain}>
                      <path d="M0.847607 11.7852C0.655207 11.7852 0.462808 11.712 0.316408 11.5645C0.0239078 11.2715 0.0249076 10.7969 0.318408 10.504L4.18271 6.65152C4.32481 6.50992 4.40291 6.32042 4.40291 6.11932C4.40291 5.91912 4.32481 5.73062 4.18271 5.58902L0.318008 1.73552C0.025008 1.44252 0.0241079 0.967921 0.316508 0.675022C0.608508 0.381122 1.08361 0.381121 1.37751 0.673021L5.24181 4.52652C5.66761 4.95132 5.90241 5.51672 5.90291 6.11932C5.90341 6.72192 5.66851 7.28732 5.24181 7.71402L1.37711 11.5665C1.23111 11.712 1.03901 11.7852 0.847607 11.7852Z" fill="#757676" />
                    </svg>
                    <div className={styles.leftsection}>
                      <div className={styles.nameblock}>{handleInitials(data.UserName)}</div>
                      <div className={styles.namecontent}> 
                        <h3>{data.UserName} <span className={styles.triggertxt}>{liveSessions?.some((session : any) => data?.ext == session?.agentExt && session.isTrigger === 1) && 'Triggered'}</span></h3>  
                        <p>
                          {data?.statusName?.toLowerCase() === "busy" ? (
                            <CcassstatusDot className="stsBlock busy" />
                          ) : data?.statusName?.toLowerCase() === "ready" ? (
                            <CcassstatusDot className="stsBlock ready" />
                          ) : data?.statusName?.toLowerCase() === "break" ? (
                            <CcassstatusDot className="stsBlock break" />
                          ) : data?.statusName?.toLowerCase() === "away" ? (
                            <CcassstatusDot className="stsBlock away" />
                          ) : data?.statusName?.toLowerCase() === "transfer only" ? (
                            <CcassstatusDot className="stsBlock transferOnly" />
                          ) : data?.statusName?.toLowerCase() === "offline" ? (
                            <CcassstatusDot className="stsBlock offline" />
                          ) : (
                            <CcassstatusDot className="stsBlock notReady" />
                          )}
                          {data.statusName}
                        </p>
                      </div>                
                    </div>
                    <div className={styles.rightsection}>
                      {liveSessions.map((dt: any) => {
                        if (data?.ext === dt?.agentExt) {

                          const agentKey = `${dt.agentExt}_${dt.channelType === "Call"}_${dt.channelType === "Chat"}_${dt.channelType === "Sms"}_${dt.channelType === "Email"}_${dt.channelType === "Whatsapp"}_${dt.channelType === "Facebook"}_${dt.channelType === "Instagram"}`;
                          if (!displayedAgents.has(agentKey)) {
                            displayedAgents.add(agentKey);

                            const communicationChannelsCount = (dt.channelType === "Call" ? 1 : 0) + (dt.channelType === "Chat" ? 1 : 0) + (dt.channelType === "Sms" ? 1 : 0) + (dt.channelType === "Email" ? 1 : 0) + (dt.channelType === "Whatsapp" ? 1 : 0) +  (dt.channelType === "Facebook" ? 1 : 0) + (dt.channelType === "Instagram" ? 1 : 0) ;
                            return (

                              <div key={agentKey} >

                                {dt.channelType === "Call" && <img src={callsmall} alt="Call icon" />}
                                {dt.channelType === "Chat" && <img src={chatsmall} alt="Chat icon" />}
                                {dt.channelType === "Sms" && <img src={sms} alt="SMS icon" />}
                                {dt.channelType === "Email" && <img src={email} alt="Email icon" />}
                                {dt.channelType === "Whatsapp" && <img src={whatsapp} alt="Whatsapp icon" />}
                                {dt.channelType === "Facebook" && <img src={fbs} alt="Fb icon" />}
                                {dt.channelType === "Instagram" && <img src={instagram} alt="Insta icon" />}
                                

                                {communicationChannelsCount > 1 && (
                                  <div className={styles.smallcounts}>+{communicationChannelsCount - 3}</div>
                                )}
                              </div>

                            );
                          }
                        }
                      })}
                    </div>



                  </div>
                  {data?.showDetails
                    ? <>{
                      liveSessions.map((dt: any) => {
                        if (data?.ext === dt?.agentExt) {
                          return <div className={styles.agenttrackersub}>
                            <div className={styles.agenttrackerlists}>
                              <div className={`${styles.leftsection} ${styles.leftsectionimg}`}>
                                {dt?.channelType === 'Sms' ? <img src={smsbig} /> : ''}
                                {dt?.channelType === 'Whatsapp' ? <img src={whatsapp} /> : ''}
                                {dt?.channelType === 'Email' ? <img src={mailicon} /> : ''}
                                {dt?.channelType === 'Chat' ? <img src={mailb} /> : ''}
                                {dt?.channelType === 'Call' ? <img src={call} /> : ''}
                                {dt.channelType === "Facebook" ? <img src={fbl} alt="Fb icon" /> : ''}
                                {dt.channelType === "Instagram" ? <svg className={styles.agentlistwidth} width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="12" fill="#FD5161"></rect><path d="M20.6982 12.8214H15.3C13.6431 12.8214 12.3 14.1645 12.3 15.8214V21.1789C12.3 22.8358 13.6431 24.1788 15.3 24.1788H20.6982C22.3551 24.1788 23.6982 22.8358 23.6982 21.1789V15.8214C23.6982 14.1645 22.3551 12.8214 20.6982 12.8214ZM21.3516 19.1691C21.098 20.5059 20.0045 21.5993 18.6676 21.8526C16.2614 22.3085 14.1911 20.2387 14.6462 17.8326C14.899 16.4959 15.9919 15.4021 17.3284 15.1478C19.7359 14.6899 21.8083 16.7616 21.3516 19.1691ZM21.5713 15.7562C21.1262 15.7562 20.7651 15.3953 20.7651 14.9501C20.7651 14.5049 21.1262 14.1439 21.5713 14.1439C22.0164 14.1439 22.3775 14.5047 22.3775 14.9501C22.3775 15.3955 22.0164 15.7562 21.5713 15.7562Z" fill="white"></path><path d="M22.4745 9.52295H13.5234C11.0381 9.52295 9.02344 11.5376 9.02344 14.0229V22.9772C9.02344 25.4625 11.0381 27.4772 13.5234 27.4772H22.4746C24.9599 27.4772 26.9746 25.4625 26.9746 22.9772V14.0229C26.9746 11.5376 24.9598 9.52295 22.4745 9.52295ZM24.6981 21.1789C24.6981 23.3879 22.9072 25.1788 20.6981 25.1788H15.2999C13.0908 25.1788 11.2999 23.3879 11.2999 21.1789V15.8214C11.2999 13.6123 13.0908 11.8214 15.2999 11.8214H20.6981C22.9072 11.8214 24.6981 13.6123 24.6981 15.8214V21.1789Z" fill="white"></path><path d="M18.539 16.3964C16.9277 16.0051 15.5046 17.4273 15.8951 19.0387C16.0788 19.7966 16.7 20.4185 17.4576 20.6033C19.0698 20.9964 20.4946 19.5726 20.1026 17.9599C19.9184 17.2021 19.2968 16.5805 18.539 16.3964Z" fill="white" ></path></svg>: ''}

                                <div className={styles.namecontent}>
                                  <h3>{dt?.customerName || "New Customer"}  <span className={styles.triggertxt}>{dt?.isTrigger === 1 && 'Triggered'}</span></h3>
                                  <p><svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <path d="M6.19972 0.769775H1.89992C1.54102 0.769775 1.25002 1.06078 1.25002 1.42018C1.25002 1.77958 1.54102 2.07058 1.89992 2.07058H5.62942L0.340816 7.35968C0.0869156 7.61358 0.0869156 8.02568 0.340816 8.27958C0.467816 8.40658 0.633815 8.46997 0.800315 8.46997C0.966815 8.46997 1.13282 8.40648 1.25982 8.27958L6.54982 2.98908V6.72008C6.54982 7.07947 6.84082 7.37048 7.19972 7.37048C7.55862 7.37048 7.84962 7.07947 7.84962 6.72008V2.42028C7.84962 1.51008 7.10942 0.769775 6.19972 0.769775Z" fill="#575CFF" />
                                  </svg>{dt?.queueName || "-"}</p>           
                                </div>
                              </div>
                              {dt?.channelType === 'Call' ?
                                <div className={styles.rightsection}>
                                  <div className={styles.namecontent}>
                                    <h3>{
                                      dt?.customerNumber
                                    }</h3>
                                    <p>{calculateFormattedTime(dt.sessionStartTime)}</p>
                                  </div>
                                  <div className={styles.hoverbadge}>
                                    <div className={styles.callAction} onClick={() => listenAction(data)}>
                                      <button className={styles.agentbtns}><span className="icon__Listen16" />Listen</button>
                                    </div>
                                    {/* <div className={styles.btns} >Listen</div> */}
                                    {/* <div className={styles.btns}onClick={() => doWhisper()}>Whisper</div>
                                <div className={styles.btns}onClick={() => doBarge()}>Barge</div> */}
                                  </div>
                                </div>
                                : <div className={styles.rightsection}>
                                  <div className={styles.namecontent}>
                                    <h3> {dt?.channelType === 'Chat' || dt?.channelType === 'Sms' ?
                                      dt?.customerNumber :
                                      dt?.channelType === 'Email' ?
                                        dt?.email :
                                        '-'
                                    }</h3>
                                    <p>{calculateFormattedTime(dt.sessionStartTime)}</p>
                                  </div>
                                  {dt?.channelType === "Chat"
                                    ? <div className={styles.hoverbadge}>
                                      <div className={styles.btns} onClick={() => handleAgentChats(dt, "view")}>View</div>
                                      <div className={styles.btns} onClick={() => handleAgentChats(dt, "whisper")}>Whisper</div>
                                      {/* <div className={styles.btns} onClick={() => handleAgentChats(dt, "barge")}>Barge</div> */}
                                    </div>
                                    : <></>}
                                </div>}
                            </div>
                          </div>
                        }
                      })
                    }</>
                    : ''}
                </div>
              </>
            </Fragment>)
          }else if (
  LoginCcaasUserDetails?.roleid === 5 &&
  data?.report_to_UserID === LoginCcaasUserDetails?.UserID
)
 {
            return (<Fragment key={index}>
              <>
                <div className={styles.agenttrackernew}>
                  <div className={styles.agenttrackermain} onClick={() => handleShowValue(data, data?.showDetails)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="12" viewBox="0 0 6 12" fill="none" className={styles.arrowmain}>
                      <path d="M0.847607 11.7852C0.655207 11.7852 0.462808 11.712 0.316408 11.5645C0.0239078 11.2715 0.0249076 10.7969 0.318408 10.504L4.18271 6.65152C4.32481 6.50992 4.40291 6.32042 4.40291 6.11932C4.40291 5.91912 4.32481 5.73062 4.18271 5.58902L0.318008 1.73552C0.025008 1.44252 0.0241079 0.967921 0.316508 0.675022C0.608508 0.381122 1.08361 0.381121 1.37751 0.673021L5.24181 4.52652C5.66761 4.95132 5.90241 5.51672 5.90291 6.11932C5.90341 6.72192 5.66851 7.28732 5.24181 7.71402L1.37711 11.5665C1.23111 11.712 1.03901 11.7852 0.847607 11.7852Z" fill="#757676" />
                    </svg>
                    <div className={styles.leftsection}>
                      <div className={styles.nameblock}>{handleInitials(data.UserName)}</div>
                      <div className={styles.namecontent}> 
                        <h3>{data.UserName} <span className={styles.triggertxt}>{liveSessions?.some((session : any) => data?.ext === session?.agentExt && session.isTrigger === 1) && 'Triggered'}</span></h3>  
                        <p>
                          {data?.statusName?.toLowerCase() === "busy" ? (
                            <CcassstatusDot className="stsBlock onCall" />
                          ) : data?.statusName?.toLowerCase() === "ready" ? (
                            <CcassstatusDot className="stsBlock ready" />
                          ) : data?.statusName?.toLowerCase() === "break" ? (
                            <CcassstatusDot className="stsBlock break" />
                          ) : data?.statusName?.toLowerCase() === "away" ? (
                            <CcassstatusDot className="stsBlock away" />
                          ) : data?.statusName?.toLowerCase() === "transfer only" ? (
                            <CcassstatusDot className="stsBlock transferOnly" />
                          ) : data?.statusName?.toLowerCase() === "offline" ? (
                            <CcassstatusDot className="stsBlock offline" />
                          ) : (
                            <CcassstatusDot className="stsBlock notReady" />
                          )}
                          {data.statusName}
                        </p>
                      </div>                
                    </div>
                    <div className={styles.rightsection}>
                      {liveSessions.map((dt: any) => {
                        if (data?.ext === dt?.agentExt) {

                          const agentKey = `${dt.agentExt}_${dt.channelType === "Call"}_${dt.channelType === "Chat"}_${dt.channelType === "Sms"}_${dt.channelType === "Email"}_${dt.channelType === "Whatsapp"}_${dt.channelType === "Facebook"}_${dt.channelType === "Instagram"}`;
                          if (!displayedAgents.has(agentKey)) {
                            displayedAgents.add(agentKey);

                            const communicationChannelsCount = (dt.channelType === "Call" ? 1 : 0) + (dt.channelType === "Chat" ? 1 : 0) + (dt.channelType === "Sms" ? 1 : 0) + (dt.channelType === "Email" ? 1 : 0) + (dt.channelType === "Whatsapp" ? 1 : 0) +  (dt.channelType === "Facebook" ? 1 : 0) + (dt.channelType === "Instagram" ? 1 : 0) ;
                            return (

                              <div key={agentKey} >

                                {dt.channelType === "Call" && <img src={callsmall} alt="Call icon" />}
                                {dt.channelType === "Chat" && <img src={chatsmall} alt="Chat icon" />}
                                {dt.channelType === "Sms" && <img src={sms} alt="SMS icon" />}
                                {dt.channelType === "Email" && <img src={email} alt="Email icon" />}
                                {dt.channelType === "Whatsapp" && <img src={whatsapp} alt="Whatsapp icon" />}
                                {dt.channelType === "Facebook" && <img src={fbl} alt="Fb icon" />}
                                {dt.channelType === "Instagram" && <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="36" height="36" rx="12" fill="#FD5161"></rect><path d="M20.6982 12.8214H15.3C13.6431 12.8214 12.3 14.1645 12.3 15.8214V21.1789C12.3 22.8358 13.6431 24.1788 15.3 24.1788H20.6982C22.3551 24.1788 23.6982 22.8358 23.6982 21.1789V15.8214C23.6982 14.1645 22.3551 12.8214 20.6982 12.8214ZM21.3516 19.1691C21.098 20.5059 20.0045 21.5993 18.6676 21.8526C16.2614 22.3085 14.1911 20.2387 14.6462 17.8326C14.899 16.4959 15.9919 15.4021 17.3284 15.1478C19.7359 14.6899 21.8083 16.7616 21.3516 19.1691ZM21.5713 15.7562C21.1262 15.7562 20.7651 15.3953 20.7651 14.9501C20.7651 14.5049 21.1262 14.1439 21.5713 14.1439C22.0164 14.1439 22.3775 14.5047 22.3775 14.9501C22.3775 15.3955 22.0164 15.7562 21.5713 15.7562Z" fill="white"></path><path d="M22.4745 9.52295H13.5234C11.0381 9.52295 9.02344 11.5376 9.02344 14.0229V22.9772C9.02344 25.4625 11.0381 27.4772 13.5234 27.4772H22.4746C24.9599 27.4772 26.9746 25.4625 26.9746 22.9772V14.0229C26.9746 11.5376 24.9598 9.52295 22.4745 9.52295ZM24.6981 21.1789C24.6981 23.3879 22.9072 25.1788 20.6981 25.1788H15.2999C13.0908 25.1788 11.2999 23.3879 11.2999 21.1789V15.8214C11.2999 13.6123 13.0908 11.8214 15.2999 11.8214H20.6981C22.9072 11.8214 24.6981 13.6123 24.6981 15.8214V21.1789Z" fill="white"></path><path d="M18.539 16.3964C16.9277 16.0051 15.5046 17.4273 15.8951 19.0387C16.0788 19.7966 16.7 20.4185 17.4576 20.6033C19.0698 20.9964 20.4946 19.5726 20.1026 17.9599C19.9184 17.2021 19.2968 16.5805 18.539 16.3964Z" fill="white"></path></svg>}

                                {communicationChannelsCount > 1 && (
                                  <div className={styles.smallcounts}>+{communicationChannelsCount - 3}</div>
                                )}
                              </div>

                            );
                          }
                        }
                      })}
                    </div>



                  </div>
                  {data?.showDetails
                    ? <>{
                      liveSessions.map((dt: any) => {
                        if (data?.ext === dt?.agentExt) {
                          return <div className={styles.agenttrackersub}>
                            <div className={styles.agenttrackerlists}>
                              <div className={styles.leftsection}>
                                {dt?.channelType === 'Sms' ? <img src={smsbig} /> : ''}
                                {dt?.channelType === 'Whatsapp' ? <img src={whatsapp} /> : ''}
                                {dt?.channelType === 'Email' ? <img src={mailicon} /> : ''}
                                {dt?.channelType === 'Chat' ? <img src={mailb} /> : ''}
                                {dt?.channelType === 'Call' ? <img src={call} /> : ''}
                                {dt.channelType === "Facebook" ? <img src={fbl} alt="Fb icon" /> : ''}
                                {dt.channelType === "Instagram" ? <img src={insta} alt="Insta icon" /> : ''}

                                <div className={styles.namecontent}>
                                  <h3>{dt?.customerName || "New Customer"}  <span className={styles.triggertxt}>{dt?.isTrigger === 1 && 'Triggered'}</span></h3>
                                  <p><svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                                    <path d="M6.19972 0.769775H1.89992C1.54102 0.769775 1.25002 1.06078 1.25002 1.42018C1.25002 1.77958 1.54102 2.07058 1.89992 2.07058H5.62942L0.340816 7.35968C0.0869156 7.61358 0.0869156 8.02568 0.340816 8.27958C0.467816 8.40658 0.633815 8.46997 0.800315 8.46997C0.966815 8.46997 1.13282 8.40648 1.25982 8.27958L6.54982 2.98908V6.72008C6.54982 7.07947 6.84082 7.37048 7.19972 7.37048C7.55862 7.37048 7.84962 7.07947 7.84962 6.72008V2.42028C7.84962 1.51008 7.10942 0.769775 6.19972 0.769775Z" fill="#575CFF" />
                                  </svg>{dt?.queueName || "-"}</p>           
                                </div>
                              </div>
                              {dt?.channelType === 'Call' ?
                                <div className={styles.rightsection}>
                                  <div className={styles.namecontent}>
                                    <h3>{
                                      dt?.customerNumber
                                    }</h3>
                                    <p>{calculateFormattedTime(dt.sessionStartTime)}</p>
                                  </div>
                                  <div className={styles.hoverbadge}>
                                    <div className={styles.callAction} onClick={() => listenAction(data)}>
                                      <button className={styles.agentbtns}><span className="icon__Listen16" />Listen</button>
                                    </div>
                                    {/* <div className={styles.btns} >Listen</div> */}
                                    {/* <div className={styles.btns}onClick={() => doWhisper()}>Whisper</div>
                                <div className={styles.btns}onClick={() => doBarge()}>Barge</div> */}
                                  </div>
                                </div>
                                : <div className={styles.rightsection}>
                                  <div className={styles.namecontent}>
                                    <h3> {dt?.channelType === 'Chat' || dt?.channelType === 'Sms' ?
                                      dt?.customerNumber :
                                      dt?.channelType === 'Email' ?
                                        dt?.email :
                                        '-'
                                    }</h3>
                                    <p>{calculateFormattedTime(dt.sessionStartTime)}</p>
                                  </div>
                                  {dt?.channelType === "Chat"
                                    ? <div className={styles.hoverbadge}>
                                      <div className={styles.btns} onClick={() => handleAgentChats(dt, "view")}>View</div>
                                      <div className={styles.btns} onClick={() => handleAgentChats(dt, "whisper")}>Whisper</div>
                                      {/* <div className={styles.btns} onClick={() => handleAgentChats(dt, "barge")}>Barge</div> */}
                                    </div>
                                    : <></>}
                                </div>}
                            </div>
                          </div>
                        }
                      })
                    }</>
                    : ''}
                </div>
              </>
            </Fragment>)
          }
        })
        }
      </>
  )
}

export default AgentStatusTracker;
